import * as angular from 'angular';
import { ChartDirectiveBase } from './ChartDirectiveBase';
import { Margins } from '../../../models/index';
import { SvgManager } from '../../../charting/SvgManager';
import { ICategoricalChartOptions, SplitCategoricalChart } from '../../../charting/index';
import { IDynamicCompileService } from '../../services/dynamicCompileService';

export interface IcategoricalChartScope extends angular.IScope {
    data: any[];
    series: any[];
    options: ICategoricalChartOptions;
    ratio?: number;
}

export class CategoricalChartDirective extends ChartDirectiveBase implements angular.IDirective {
    static directiveId = 'wtCategoricalChart';

    constructor(private _dynamicCompileService: IDynamicCompileService) {
        super();
        this.scope = {
            series: '=',
            data: '=',
            options: '=',
            ratio: '<?'
        };
        this.link.bind(this);
    }

    link = ($scope: IcategoricalChartScope, element: angular.IAugmentedJQuery, attrs, controller) => {
        const containerName = attrs.id;
        element.attr('id', containerName);
        const margins = new Margins(0, 0, 10, 0);
        const categoricalSvgManager = new SvgManager(containerName, margins);
        const categoricalChart = new SplitCategoricalChart(categoricalSvgManager);
        $scope.$watch(() => $scope.options, (newValue) => {
            if (newValue) {
                categoricalChart.options($scope.options);
                this._dynamicCompileService.compileGroup(element, <any>$scope);
            }
        }, true);
        $scope.$watchCollection(() => $scope.data, (newValue) => {
            if (newValue) {
                categoricalChart.updateData($scope.data);
            }
        });

        $scope.$watch(() => $scope.series, (newValue) => {
            if (newValue) {
                categoricalChart.updateSeries($scope.series);
                if ($scope.data) {
                    categoricalChart.updateData($scope.data);
                }
                this._dynamicCompileService.compileGroup(element, <any>$scope);
            }
        }, true);

        $scope.$watch(() => $scope.ratio, () => {
            const { ratio } = $scope;
            if (ratio) {
                categoricalSvgManager.margins(new Margins(0, 0, ratio * 10, 0));
                categoricalChart.ratio(ratio);
            }
        });
        categoricalSvgManager.addResizeFunction(() => {
            this._dynamicCompileService.compileGroup(element, <any>$scope);
        });
    }
}
